 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","admin-admin-module":"admin-admin-module","guest-guest-module":"guest-guest-module","default~cockpit-cockpit-module~cockpit-operative-cockpit-operative-module~components-ui-kit-ui-kit-m~aaf0394d":"default~cockpit-cockpit-module~cockpit-operative-cockpit-operative-module~components-ui-kit-ui-kit-m~aaf0394d","default~components-ui-kit-ui-kit-module~dashboard-dashboard-module~default-topic-default-topic-modul~caee925e":"default~components-ui-kit-ui-kit-module~dashboard-dashboard-module~default-topic-default-topic-modul~caee925e","components-ui-kit-ui-kit-module":"components-ui-kit-ui-kit-module","ideas-ideas-module":"ideas-ideas-module","customer-portal-customer-portal-module":"customer-portal-customer-portal-module","default~base-data-base-data-module~category-setting-category-setting-module~cockpit-dashboard-cockpi~e7345540":"default~base-data-base-data-module~category-setting-category-setting-module~cockpit-dashboard-cockpi~e7345540","documents-documents-module":"documents-documents-module","termine-and-todos-termine-and-todos-module":"termine-and-todos-termine-and-todos-module","default~dashboard-dashboard-module~default-topic-default-topic-module~strategy-map-strategy-map-modu~ae30135c":"default~dashboard-dashboard-module~default-topic-default-topic-module~strategy-map-strategy-map-modu~ae30135c","default~dashboard-dashboard-module~topic-topic-module~topic-trends-topic-trends-module":"default~dashboard-dashboard-module~topic-topic-module~topic-trends-topic-trends-module","dashboard-dashboard-module":"dashboard-dashboard-module","masters-masters-module":"masters-masters-module","forgot-password-forgot-password-module":"forgot-password-forgot-password-module","overview-overview-module":"overview-overview-module","category-setting-category-setting-module":"category-setting-category-setting-module","controls-controls-module":"controls-controls-module","template-template-module":"template-template-module","default~customer-admin-customer-admin-module~release-notes-release-notes-module~user-user-module":"default~customer-admin-customer-admin-module~release-notes-release-notes-module~user-user-module","release-notes-release-notes-module":"release-notes-release-notes-module","user-user-module":"user-user-module","user-setting-user-setting-module":"user-setting-user-setting-module","cockpit-operative-cockpit-operative-module":"cockpit-operative-cockpit-operative-module","cockpit-cockpit-module":"cockpit-cockpit-module","topic-trends-topic-trends-module":"topic-trends-topic-trends-module","strategie-strategie-module":"strategie-strategie-module","topic-topic-module":"topic-topic-module","customer-customer-module":"customer-customer-module","default~base-data-base-data-module~chapter-update-chapter-update-module~operative-chapter-update-ope~5d606f18":"default~base-data-base-data-module~chapter-update-chapter-update-module~operative-chapter-update-ope~5d606f18","base-data-base-data-module":"base-data-base-data-module","customer-admin-customer-admin-module":"customer-admin-customer-admin-module","topic-trend-master-topic-trend-master-module":"topic-trend-master-topic-trend-master-module","operative-dashboard-operative-dashboard-module":"operative-dashboard-operative-dashboard-module","default~operative-risk-analysis-operative-risk-analysis-module~swot-list-swot-list-swot-module":"default~operative-risk-analysis-operative-risk-analysis-module~swot-list-swot-list-swot-module","operative-risk-analysis-operative-risk-analysis-module":"operative-risk-analysis-operative-risk-analysis-module","cockpit-dashboard-cockpit-dashboard-module":"cockpit-dashboard-cockpit-dashboard-module","risk-analysis-risk-analysis-module":"risk-analysis-risk-analysis-module","strategie-dashboard-strategie-dashboard-module":"strategie-dashboard-strategie-dashboard-module","strategy-map-strategy-map-module":"strategy-map-strategy-map-module","swot-list-swot-list-swot-module":"swot-list-swot-list-swot-module","cockpit-analyzes-cockpit-analyzes-module":"cockpit-analyzes-cockpit-analyzes-module","default-topic-default-topic-module":"default-topic-default-topic-module","operative-chapter-update-operative-chapter-update-module":"operative-chapter-update-operative-chapter-update-module","chapter-update-chapter-update-module":"chapter-update-chapter-update-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
